"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InterpreterMetaFieldType;
(function (InterpreterMetaFieldType) {
    InterpreterMetaFieldType[InterpreterMetaFieldType["INTEGER_IDENTITY"] = 0] = "INTEGER_IDENTITY";
    InterpreterMetaFieldType[InterpreterMetaFieldType["INTEGER"] = 1] = "INTEGER";
    InterpreterMetaFieldType[InterpreterMetaFieldType["STRING"] = 2] = "STRING";
    InterpreterMetaFieldType[InterpreterMetaFieldType["MULTILINGUAL_STRING"] = 3] = "MULTILINGUAL_STRING";
    InterpreterMetaFieldType[InterpreterMetaFieldType["DATE"] = 4] = "DATE";
    InterpreterMetaFieldType[InterpreterMetaFieldType["DATE_TIME"] = 5] = "DATE_TIME";
    InterpreterMetaFieldType[InterpreterMetaFieldType["BOOLEAN"] = 6] = "BOOLEAN";
    InterpreterMetaFieldType[InterpreterMetaFieldType["CLASSIFIER"] = 7] = "CLASSIFIER";
    InterpreterMetaFieldType[InterpreterMetaFieldType["PARENT"] = 8] = "PARENT";
    InterpreterMetaFieldType[InterpreterMetaFieldType["MULTI_SELECT"] = 9] = "MULTI_SELECT";
    InterpreterMetaFieldType[InterpreterMetaFieldType["SUB_ENTITY"] = 10] = "SUB_ENTITY";
    InterpreterMetaFieldType[InterpreterMetaFieldType["MAIN_ENTITY"] = 11] = "MAIN_ENTITY";
    InterpreterMetaFieldType[InterpreterMetaFieldType["DECIMAL"] = 12] = "DECIMAL";
    InterpreterMetaFieldType[InterpreterMetaFieldType["BIG_DECIMAL"] = 13] = "BIG_DECIMAL";
    InterpreterMetaFieldType[InterpreterMetaFieldType["INTEGER_INSTANCE"] = 14] = "INTEGER_INSTANCE";
    InterpreterMetaFieldType[InterpreterMetaFieldType["DOCUMENT"] = 15] = "DOCUMENT";
    InterpreterMetaFieldType[InterpreterMetaFieldType["MULTILINESTRING"] = 16] = "MULTILINESTRING";
    InterpreterMetaFieldType[InterpreterMetaFieldType["WORKFLOW_STATE"] = 17] = "WORKFLOW_STATE";
    InterpreterMetaFieldType[InterpreterMetaFieldType["USER"] = 18] = "USER";
    InterpreterMetaFieldType[InterpreterMetaFieldType["LOCAL_DATE"] = 19] = "LOCAL_DATE";
    InterpreterMetaFieldType[InterpreterMetaFieldType["LOCAL_DATE_TIME"] = 20] = "LOCAL_DATE_TIME";
})(InterpreterMetaFieldType = exports.InterpreterMetaFieldType || (exports.InterpreterMetaFieldType = {}));
//# sourceMappingURL=interpreter-meta-field.js.map